<template>
  <div class="home-title" :class="{ 'home-title--center': center }">
    <p class="home-title__title">{{ title }}</p>
    <p v-if="content" class="home-title__content">{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: ['english', 'title', 'content', 'center'],
};
</script>

<style lang="scss" scoped>
.home-title {
  &__english {
    margin-bottom: 4px;

    font-family: var(--font-family-bold);
    font-weight: 500;
    font-size: 16px;
    color: #64BABF;
  }

  &__title {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 36px;
    color: #101828;

    @media (max-width: 1229px) and (min-width: 992px) {
      font-size: 32px;
    }

    @media (max-width: 991px) {
      font-size: 28px;
    }

    &::before {
      content: "";

      display: block;
      width: 32px;
      height: 3px;
      margin-right: 10px;
      background-color: var(--custom-color);
    }
  }

  &__content {
    padding-left: 42px;

    font-size: 20px;
    color: #667085;

    @media (max-width: 1229px) and (min-width: 992px) {
      font-size: 17px;
    }

    @media (max-width: 991px) {
      font-size: 15px;
    }
  }

  &--center {
    .home-title__english {
      text-align: center;
    }

    .home-title__title {
      justify-content: center;
    }

    .home-title__content {
      padding-left: 0;

      text-align: center;
    }
  }
}
</style>
